module.exports = __webpack_public_path__ + "img/GPB_top10.6717e49f.png";